
  import React from "react"
  import Component from "/Users/cg433n/Repositories/cardprint/src/layouts/index.js"
  import data from "/Users/cg433n/Repositories/cardprint/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js